export const getters = {
  getOrdersMeta($state) {
    return $state.meta;
  },
  getOrders($state) {
    return $state.records;
  },
  getPelanggan($state) {
    return $state.list_pelanggan;
  },
  getPelangganMeta($state) {
    return $state.list_meta;
  },
  getCustomersUIFlags($state) {
    return $state.uiFlags;
  },
  getPaketLangganan($state) {
    return $state.packages;
  }
};
